import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { EmotionSection } from './components/EmotionSection';
import { RegenerativeDifference } from './components/RegenerativeDifference';
import { HowItWorks } from './components/HowItWorks';
import { BeforeAfter } from './components/BeforeAfter';
import { TestimonialCarousel } from './components/TestimonialCarousel';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { ConsultationProvider } from './components/ConsultationContext';
import { ConsultationModal } from './components/ConsultationModal';
import { StickyCallBar } from './components/StickyCallBar';
export function App() {
  return <ConsultationProvider data-id="element-0">
      <div className="min-h-screen pb-14 bg-cream text-foreground font-sans selection:bg-gold/20 selection:text-primary" data-id="element-1">
        <Header data-id="element-2" />
        <main data-id="element-3">
          <HeroSection data-id="element-4" />
          <BeforeAfter data-id="element-5" />
          <TrustBar data-id="element-6" />
          <EmotionSection data-id="element-7" />
          <RegenerativeDifference data-id="element-8" />
          <HowItWorks data-id="element-9" />
          <TestimonialCarousel data-id="element-10" />
          <FAQSection data-id="element-11" />
          <FinalCTA data-id="element-12" />
        </main>
        <Footer data-id="element-13" />
        <ConsultationModal data-id="element-14" />
        <StickyCallBar data-id="element-15" />
      </div>
    </ConsultationProvider>;
}